/* eslint-disable import/no-extraneous-dependencies */
import JSConfetti from 'js-confetti';

export default () => {
    let confetti = null;
    onMounted(() => {
        confetti = new JSConfetti();
    });

    const triggerConfetti = () => {
        confetti.addConfetti({
            emojis: ['🧀', '🥛', '🍀', '🧀','🐮','🐮', '🥛'],
            emojiSize: 35,
        });

        confetti.addConfetti({
            confettiNumber: 300,
            confettiColors: [
                '#004EBD', '#CCDCF2', '#F2F6FC', '#E5EDF8', '#83D3FF',
            ],
        });
    };

    return {
        triggerConfetti,
    };
};
